const colors = {
  button: 'darkgreen',
  notice: 'orange',
  header: 'darkgreen',
  danger: 'darkred',
};

export default colors;
